<template>
  <div id="content-container">
    <div class="panel">
      <el-tabs v-model="activeName">
        <el-tab-pane label="配件履历表" name="life_data"></el-tab-pane>
        <el-tab-pane label="未使用物资统计" name="not_used_data"></el-tab-pane>
      </el-tabs>
      <LifeData
        :category="category"
        v-if="activeName == 'life_data'"
      ></LifeData>
      <NotUsedStatistics
        :category="category"
        v-if="activeName == 'not_used_data'"
      ></NotUsedStatistics>
    </div>
  </div>
</template>

<script>
import LifeData from './life_data/index.vue'
import NotUsedStatistics from './not_used_data/index.vue'

export default {
  components: {
    LifeData,
    NotUsedStatistics,
  },
  data() {
    return {
      category: 1,
      activeName: 'life_data',
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      this.activeName = filter.tab || 'life_data'
    } else {
      this.activeName = 'life_data'
    }
  },
}
</script>